import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import textTranslates from './translate.json';
import ShowRodoClause from './ShowRodoClause';
import "./RodoClause.scss";
import {openShowRodoClauseModal} from '../../actions/Modal';
class RodoClauseButton extends Component {
    
    openShowRodoClauseModal = () => this.props.openShowRodoClauseModal();

    openExternalTerms = () => {
        window.open( 
            "https://www.elitameble.pl/o-nas/polityka-prywatnosci/", "_blank"); 
    }

    render(){
        return(
            <div 
                id="rodo-clause"
                className="col-xs-12 rodo-clause">
                <Title
                    id="rodo-clause-title"
                    title={textTranslates.rodoTitle}/>
                    <div className="col-xs-12">
                        <ShowRodoClause onShowRodoClauseClick={this.openExternalTerms} />
                    </div>
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        openShowRodoClauseModal: () => dispatch(openShowRodoClauseModal()),
    };
};

RodoClauseButton.propTypes = {
    //prop: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(RodoClauseButton);


// WEBPACK FOOTER //
// ./src/components/RodoClause/RodoClause.js